export default __webpack_public_path__ + "media/images/celeste_lock-8c054625a0156a15e4c315d7dcc8ba59.png";